import { defineStore } from 'pinia';

const DARK_THEME_STORAGE_KEY = 'darkTheme';

export function getInitialDarkTheme() {
    if (typeof localStorage !== 'undefined') {
        try {
            const savedTheme = localStorage.getItem(DARK_THEME_STORAGE_KEY);
            if (savedTheme === 'true' || savedTheme === 'false') {
                return savedTheme === 'true';
            }
        } catch (error) {
            // Storage can be blocked in private or embedded contexts.
        }
    }

    return Boolean(
        typeof window !== 'undefined' &&
            window.matchMedia &&
            window.matchMedia('(prefers-color-scheme: dark)').matches
    );
}

export function applyDarkThemeToDocument(value) {
    const isDark = Boolean(value);

    if (typeof localStorage !== 'undefined') {
        try {
            localStorage.setItem(DARK_THEME_STORAGE_KEY, String(isDark));
        } catch (error) {
            // Theme should still apply even when persistence is unavailable.
        }
    }

    if (typeof document === 'undefined') {
        return;
    }

    const root = document.documentElement;
    root.classList.toggle('theme--dark', isDark);
    root.classList.toggle('theme--light', !isDark);
    root.dataset.theme = isDark ? 'dark' : 'light';
    root.style.colorScheme = isDark ? 'dark' : 'light';

    if (document.body) {
        document.body.classList.toggle('theme--dark', isDark);
        document.body.classList.toggle('theme--light', !isDark);
        document.body.dataset.theme = isDark ? 'dark' : 'light';
    }

    const themeMeta = document.querySelector('meta[name="theme-color"]');
    if (themeMeta) {
        themeMeta.setAttribute('content', isDark ? '#0b0f17' : '#ffffff');
    }
}

export const useGeneralStore = defineStore('general', {
    // State is the same as in Vuex
    state: () => ({
        darkTheme: getInitialDarkTheme()
    }),

    // Getters remain the same
    getters: {
        getDarkTheme: state => state.darkTheme
    },

    // Actions (former mutations)
    actions: {
        setDarkTheme(value) {
            const isDark = Boolean(value);
            this.darkTheme = isDark;
            applyDarkThemeToDocument(isDark);
        }
    }
});
